export default __webpack_public_path__ + "static/media/About-min.00a387c6.jpg";